import React from 'react';

const ErrorMessage = ({ error, onRetry, className = '', title = 'حدث خطأ' }) => {
  if (!error) return null;

  return (
    <div className={`card ${className}`}>
      <div className="card-body">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-error-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="mr-3 flex-1">
            <h3 className="text-sm font-medium text-error-800">
              {title}
            </h3>
            <div className="mt-2 text-sm text-error-700">
              <p>{error}</p>
            </div>
            {onRetry && (
              <div className="mt-4">
                <button
                  type="button"
                  onClick={onRetry}
                  className="btn btn-error btn-sm"
                >
                  إعادة المحاولة
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;

